import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  SendOutlined,
  StopOutlined,
} from '@ant-design/icons';

export const stateConfig = {
  SIN_ASIGNAR: {
    label: 'Sin asignar',
    color: '#8c8c8c',
    bgColor: '#f5f5f5',
    textColor: '#595959',
    icon: <ExclamationCircleOutlined />,
  },
  ASIGNADA: {
    label: 'Asignada',
    color: '#1890ff',
    bgColor: '#e6f7ff',
    textColor: '#0050b3',
    icon: <ClockCircleOutlined />,
  },
  EN_CURSO: {
    label: 'En curso',
    color: '#fa8c16',
    bgColor: '#fff7e6',
    textColor: '#ad4e00',
    icon: <ClockCircleOutlined />,
  },
  FINALIZADA: {
    label: 'Finalizada',
    color: '#52c41a',
    bgColor: '#f6ffed',
    textColor: '#389e0d',
    icon: <CheckCircleOutlined />,
  },
  ENVIADA: {
    label: 'Enviada',
    color: '#722ed1',
    bgColor: '#f9f0ff',
    textColor: '#531dab',
    icon: <SendOutlined />,
  },
  CANCELADA: {
    label: 'Cancelada',
    color: '#ff4d4f',
    bgColor: '#fff2f0',
    textColor: '#cf1322',
    icon: <StopOutlined />,
  },
};

export const getStateConfig = (status) => stateConfig[status] || stateConfig.SIN_ASIGNAR;
